import { ServicesLabel } from "../services";

export  const servicesLabels: ServicesLabel[] = [
    {
      label: "Sl. No.",
      flex: 0.5,
    },
    {
      label: "Name of Service / Person",
      flex: 1.8,
    },
    {
      label: "Surveyor",
      flex: 1,
    },
    {
      label: "Service Category",
      flex: 1.5,
    },
    {
      label: "State",
      flex: 1,
    },
    {
      label: "Contact Number",
      flex: 1,
    },
    {
      label: "Status",
      flex: 0.7,
    },
    {
      label: "Action",
    },
  ];
